import {getPlayRank, getPlayRankList, createPlayRank, updatePlayRank} from "api-v3";
import {convertMilliseconds, convertToTimeString, getKSTDateString} from "utils";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import View from "./View";

export default function Container({isCloseUsable = false, singlePopup = false, dismiss}) {
  const {id, name} = useSelector(state => state.userinfo);
  const gameState = useSelector(state => state.game);
  const [myRank, setMyRank] = useState({});
  const [ranks, setRanks] = useState([]);

  useEffect(() => {
    if (gameState.messageFromGame?.record) {
      const updateRecord = () => {
        try {
          getMyRank();
          get30Ranks();
        } catch (error) {
          console.log(error);
        }
      };

      updateRecord(gameState.messageFromGame.record);
    } else {
      getMyRank();
      get30Ranks();
    }
  }, []);

  const getMyRank = async () => {
    try {
      const params = {worldType: "RUNNERZ"};

      getPlayRank(params).then(body => {
        if (body.data) {
          body.data.best = convertRecord(body.data.best);
          setMyRank(body);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const get30Ranks = async () => {
    try {
      const params = {worldType: "RUNNERZ"};

      getPlayRankList(params).then(body => {
        if (body?.data) {
          body.data.items.forEach(user => {
            user.best = convertRecord(user.best);
          });
          setRanks(body.data.items);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const convertRecord = record => {
    if (!record || record >= 3600000) return "-";
    const {minutes, seconds, milliseconds} = convertMilliseconds(record);
    return convertToTimeString([minutes, seconds, milliseconds]);
  };

  return (
    <View myRank={myRank} ranks={ranks} myId={id} isCloseUsable={isCloseUsable} singlePopup={singlePopup} name={name} dismiss={dismiss} />
  );
}
